<template>
    <div class="stylesheet-results">
        <table class="control-table">
            <thead class="control-table__head">
                <tr class="control-table__row">
                    <th class="control-table__cell" style="width: 150px">
                        <div class="control-table__cell-inner">
                            <span v-t="'crm.stylesheet.results.id'" />
                            <TableSorting
                                v-if="sortBy.includes('id')"
                                v-model="ordering"
                                field="id"
                            />
                        </div>
                    </th>
                    <th class="control-table__cell">
                        <div class="control-table__cell-inner">
                            <span v-t="'crm.stylesheet.results.target'" />
                            <TableSorting
                                v-if="sortBy.includes('target')"
                                v-model="ordering"
                                field="target"
                            />
                        </div>
                    </th>
                    <th class="control-table__cell">
                        <div class="control-table__cell-inner">
                            <span v-t="'crm.stylesheet.results.explanation'" />
                            <TableSorting
                                v-if="sortBy.includes('explanation')"
                                v-model="ordering"
                                field="explanation"
                            />
                        </div>
                    </th>
                    <th v-if="!readOnly" class="control-table__cell" style="width: 150px">
                        &nbsp;
                    </th>
                </tr>
            </thead>
            <tbody>
                <template v-if="!loading">
                    <tr v-if="isEmpty" class="control-table__row">
                        <td class="table__cell table__cell--centered table__empty" colspan="4">
                            <span v-t="'crm.stylesheet.noData'" />
                        </td>
                    </tr>
                    <tr v-else-if="notFound" class="control-table__row">
                        <td class="table__cell table__cell--centered table__empty" colspan="4">
                            <span v-t="'crm.stylesheet.noResults'" />
                        </td>
                    </tr>
                </template>
                <tr v-for="item in items" :key="item.id" class="control-table__row">
                    <td class="control-table__cell">
                        <span v-text="item.id" />
                    </td>
                    <td class="control-table__cell">
                        <span v-text="item.target" />
                    </td>
                    <td class="control-table__cell">
                        <span v-text="item.explanation" />
                    </td>
                    <td v-if="!readOnly" class="control-table__cell">
                        <div class="stylesheet-results__actions">
                            <slot name="actions" :item="item">
                                <StylesheetEdit
                                    v-if="schema && item.permissions.partial_update"
                                    :model-value="item"
                                    :schema="schema.partial_update"
                                    @submit="updateRule"
                                />
                                <StylesheetDelete
                                    v-if="item.permissions.destroy"
                                    @confirmed="deleteRule(item)"
                                />
                            </slot>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import TableSorting from '@speechki-frontend/shared/ui/TableSorting';
import { StylesheetDelete, StylesheetEdit } from '../';

export default {
    name: 'StylesheetResults',
    components: {
        TableSorting,
        StylesheetDelete,
        StylesheetEdit,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        schema: {
            type: Object,
            default: () => ({}),
        },
        items: {
            type: Array,
            default: () => [],
        },
        isEmpty: {
            type: Boolean,
            default: true,
        },
        notFound: {
            type: Boolean,
            default: false,
        },
        sortBy: {
            type: Array,
            default: () => [],
        },
        initialOrdering: {
            type: String,
            default: '-id',
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            ordering: this.initialOrdering,
        };
    },
    watch: {
        ordering() {
            this.$emit('sort', this.ordering);
        },
    },
    methods: {
        updateRule(event) {
            this.$emit('updateRule', event);
        },
        deleteRule(event) {
            this.$emit('deleteRule', event);
        },
    },
};
</script>

<style src="./StylesheetResults.scss" lang="scss"></style>
